import { render, staticRenderFns } from "./OrderImport.vue?vue&type=template&id=4fa54bfd&scoped=true&"
import script from "./OrderImport.vue?vue&type=script&lang=js&"
export * from "./OrderImport.vue?vue&type=script&lang=js&"
import style0 from "./OrderImport.vue?vue&type=style&index=0&id=4fa54bfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa54bfd",
  null
  
)

export default component.exports